<template>
  <div>
    <v-dialog
      v-model="mod_dialog"
      flat
      persistent
      max-width="900"
      content-class="br_none"
    >

      <v-row class="modal__content__wrapper">
        <v-col cols="12" class="pa-0">
          <div class="header__wrap">
            <div>
              <h2 class="modal__title" v-show="procStatus == 'MOD'">{{ $t('component.representative.edit_representative') }}</h2>
              <h2 class="modal__title" v-show="procStatus == 'VIEW'">{{ $t('component.representative.view_representative') }}</h2>
            </div>
            <div class="modal__close__wrap">
              <v-btn @click="fnClosePopup()"></v-btn>
            </div>
          </div>
        </v-col>

        <v-col cols="12" class="pa-0">
          <ValidationObserver ref="observer">
            <v-form v-model="valid">

              <perfect-scrollbar class="h420" id="representative_wrapper">
                <div class="modal__content__inner__new">

                  <v-row class="ma-0">
                    <v-col cols="12">
                      <v-row class="">
                        <v-col class="">
                          <label class="nec_title"><i>*</i> {{ $t('component.representative.name') }}</label>

                          <v-row>
                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="box__title">{{ $t('component.representative.en') }}</div>
                                <div class="text__input__icontype__tf">
                                  <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.name')" :rules="{required: true}">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="br_none ie_inpt login_text_field text-left"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="name_en"
                                    :error-messages="errors"
                                  ></v-text-field>
                                  </ValidationProvider>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="text__input__icontype__tf">
                                  <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.name')" :rules="{required: true}">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="type_ar ie_inpt login_text_field text-right br_none"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="name_ar"
                                    :error-messages="errors"
                                  ></v-text-field>
                                  </ValidationProvider>
                                </div>
                                <div class="box__title">{{ $t('component.representative.ar') }}</div>
                              </div>
                            </v-col>
                          </v-row>

                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('component.representative.address') }}</label>
                      <v-row class="">
                        <v-col cols="12" class="pt-0">
                          <div class="text__input__icontype not__ltr">
                            <div class="box__title">{{ $t('component.representative.en') }}</div>
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.address')" :rules="{required: true}">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="address_en"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" class="pt-0">
                          <div class="text__input__icontype not__ltr">
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.address')" :rules="{required: true}">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="type_ar ie_inpt login_text_field text-right br_none"
                                :disabled="procStatus == 'VIEW'"
                                v-model="address_ar"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                            <div class="box__title">{{ $t('component.representative.ar') }}</div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                      <v-row class="">
                        <v-col class="">
                          <label class="nec_title mb--10">{{ $t('component.representative.pobox') }}</label>
                          <v-row class="">
                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="box__title">{{ $t('component.representative.en') }}</div>
                                <div class="text__input__icontype__tf">
                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="br_none ie_inpt login_text_field text-left"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="pobox_en"
                                  ></v-text-field>
                                </div>
                              </div>
                            </v-col>

                            <v-col cols="12" md="6" class="pt-0">
                              <div class="text__input__icontype not__ltr">
                                <div class="text__input__icontype__tf">

                                  <v-text-field
                                    outlined
                                    solo
                                    flat
                                    dense
                                    clearable
                                    class="type_ar ie_inpt login_text_field text-right br_none"
                                    :disabled="procStatus == 'VIEW'"
                                    v-model="pobox_ar"

                                  ></v-text-field>

                                </div>
                                <div class="box__title">{{ $t('component.representative.ar') }}</div>
                              </div>


                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" md="6" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('component.representative.country') }}</label>
                      <div class="input_text_type_basic">
                        <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.country')" :rules="{required: true}">
                          <v-select
                            dense
                            outlined
                            class="ft-size12 br_none"
                            :disabled="procStatus == 'VIEW'"
                            :items="$vuetify.rtl ? countryArList : countryEnList"
                            v-model="nationality_code"
                            :error-messages="errors"
                          >
                          </v-select>
                        </ValidationProvider>
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" class="pt-0 pb-0">
                      <label class="nec_title"><i>*</i> {{ $t('component.representative.residence') }}</label>
                      <div class="input_text_type_basic">
                        <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.residence')" :rules="{required: true}">
                          <v-select
                            dense
                            outlined
                            class="ft-size12 br_none"
                            :disabled="procStatus == 'VIEW'"
                            :items="$vuetify.rtl ? countryArList : countryEnList"
                            v-model="residence_country_code"
                            :error-messages="errors"
                          >
                          </v-select>
                        </ValidationProvider>
                      </div>
                    </v-col>

                    <v-col cols="12" class="pt-0 pb-0">
                      <v-row class="">
                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.representative.telephone') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-phone-in-talk</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="telephone"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.representative.mobile') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-cellphone-iphone</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="mobile"
                              ></v-text-field>
                            </div>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <label class="nec_title">{{ $t('component.representative.fax') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title"><v-icon>mdi-fax</v-icon></div>
                            <div class="text__input__icontype__tf">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left"
                                :disabled="procStatus == 'VIEW'"
                                v-model="fax"
                              ></v-text-field>
                            </div>
                          </div>

                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" class="pb-0 pt-0">
                      <v-row>
                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title"><i>*</i> {{ $t('component.representative.email') }}</label>
                          <div class="text__input__icontype ">
                            <div class="box__title">@</div>
                            <div class="text__input__icontype__tf">
                              <ValidationProvider v-slot="{ errors }" :name="$t('component.applicants.email')" rules="required|email">
                              <v-text-field
                                outlined
                                solo
                                flat
                                dense
                                clearable
                                class="br_none ie_inpt login_text_field text-left email"
                                :disabled="procStatus == 'VIEW'"
                                v-model="email"
                                :error-messages="errors"
                              ></v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>


                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title">{{ $t('component.representative.registration_no') }}</label>
                          <div class="input_text_type_basic">
                            <v-text-field
                              placeholder=""
                              dense
                              outlined
                              hide-details
                              clearable
                              class="ft-size12 br_none"
                              :disabled="procStatus == 'VIEW'"
                              v-model="agent_no"
                            >
                            </v-text-field>
                          </div>
                        </v-col>


                        <v-col cols="12" md="4" class="pb-0">
                          <label class="nec_title"><i v-if="(user_group_type_code === '3803' || user_group_type_code === '3804')">* </i>{{ $t('component.representative.agent_type') }}</label>
                          <div class="input_text_type_basic">
                            <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.agent_type')" :rules="{required: (user_group_type_code === '3803' || user_group_type_code === '3804') ? true : false}">
                              <v-select
                                dense
                                outlined
                                class="ft-size12 br_none"
                                :disabled="procStatus == 'VIEW'"
                                :items="$vuetify.rtl ? agentTypeCodeListAr : agentTypeCodeListEn"
                                v-model="agent_type_code"
                                :error-messages="errors"
                              >
                              </v-select>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0 mt-15">
                          <div class="input_checkbox_type_basic ma-0">
                            <ValidationProvider v-slot="{ errors }" :rules="{required: true}">
                              <v-radio-group
                                v-model="rep_scope_type_code"
                                :error-messages="errors"
                              >
                                <template v-for="repScopeType in $vuetify.rtl ? repScopeTypeListAr : repScopeTypeListEn">
                                  <v-radio
                                    :key="repScopeType.value"
                                    :label="repScopeType.text"
                                    :value="repScopeType.value"
                                    :disabled="procStatus == 'VIEW'"
                                  ></v-radio>
                                </template>
                              </v-radio-group>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0 pa-0" v-show="rep_scope_type_code == '5102'">
                        <v-col class="pa-0" cols="1"></v-col>
                        <v-col class="pa-0" cols="11">
                          <div class="input_checkbox_type_basic row ma-0">
                            <template v-for="(applicant, i) in applicantList">
                              <v-spacer class="hidden_lr10" :key="i" v-if="i>0"></v-spacer>
                              <v-checkbox
                                style="margin-top: 0"
                                :key="applicant.seq"
                                :label="$vuetify.rtl ? applicant.name_ar : applicant.name_en"
                                :value="applicant.seq"
                                hide-details
                                v-model="selected_applicants"
                                :disabled="procStatus == 'VIEW'"
                              >
                              </v-checkbox>
                            </template>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row class="ma-0 mt-35">
                        <v-col cols="12" class="pa-0 mb-15">
                          <ValidationProvider v-slot="{ errors }"
                            :name="$t('component.representative.the_power_of_attorney')"
                            :rules="{required: (user_group_type_code === '3801') ? false : true}">
                            <label class="nec_title mb-15"><i v-if="user_group_type_code !== '3801'">*</i> {{ $t('component.representative.the_power_of_attorney') }}</label>
                            <div class="input_checkbox_type_basic column">
                              <v-radio-group
                                column
                                v-model="poa_upload_type_codes"
                                :error-messages="errors"
                              >
                                <v-row class="ma-0 pa-0">
                                  <v-col class="pa-0 align-self-center" cols="12">
                                    <v-checkbox
                                      :label="$t('component.representative.attach_power_of_attorney')"
                                      value="5201"
                                      v-model="poa_upload_type_codes"
                                      :disabled="procStatus == 'VIEW'"
                                      hide-details
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0">
                                  <v-col class="pa-0" cols="1"></v-col>
                                  <v-col class="pa-0" cols="6">
                                    <div class="input_text_type_basic file_type fileForm">
                                      <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.attach_power_of_attorney')" :rules="{required: (poa_upload_type_codes.join(',').indexOf('5201') > 1 && !poa_file_key)}">
                                        <v-file-input
                                          outlined
                                          dense
                                          :placeholder="poa_file_name ? poa_file_name : $t('common.common.no_files_selected')"
                                          :prepend-icon="$t('common.common.select_file')"
                                          class="ft-size12 br_none pb-0"
                                          style="height: 40px; max-width:350px"
                                          v-model="poaFile"
                                          :error-messages="errors"
                                          :disabled="procStatus == 'VIEW'"
                                          accept=".pdf, .jpg, .gif"
                                          @change="fnUploadFile()"
                                          clearable
                                          @click:clear="fnInitFile()"
                                          :append-icon="poa_file_name ? '$clear': ''"
                                          @click:append="fnInitFile()"
                                        >
                                        </v-file-input>
                                      </ValidationProvider>
                                    </div>
                                  </v-col>
                                </v-row>

                                <v-row class="ma-0 pa-0">
                                  <v-col class="pa-0 ma-0" cols="12">
                                    <v-checkbox
                                      :label="$t('component.representative.the_appointment_is_made_in_this_request_for')"
                                      value="5202"
                                      v-model="poa_upload_type_codes"
                                      :disabled="procStatus == 'VIEW'"
                                      hide-details
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>

                                <v-row class="ma-0 pa-0">
                                  <v-col class="pa-0 ma-0" cols="12">
                                    <v-checkbox
                                      :label="$t('component.representative.the_power_of_attorney_is_already_in_the_possession_of_the_office')"
                                      value="5203"
                                      v-model="poa_upload_type_codes"
                                      :disabled="procStatus == 'VIEW'"
                                      hide-details
                                    ></v-checkbox>
                                  </v-col>
                                </v-row>
                                <v-row class="ma-0 pa-0">
                                  <v-col class="pa-0" cols="1"></v-col>
                                  <v-col class="pa-0" cols="6">
                                    <div class="input_text_type_basic">
                                      <!--
                                        status : 1 check 일 경우  v-input--is-focused primary--text
                                                  2 close 일 경우  v-input--is-focused error--text
                                                  각 상황에 맞게 <v-text-field>에 class 추가
                                        -->

                                      <ValidationProvider v-slot="{ errors }" :name="$t('component.representative.application_no')" :rules="{required: poa_upload_type_codes.join(',').indexOf('5203') > -1}">

                                      <h2 class="title_application_no mt-0">{{ $t('component.search_application.fields.application_no') }}</h2>
                                      <div class="application__new__wrap">
                                        <v-text-field
                                          dense
                                          outlined
                                          class="br_none email"
                                          style="max-width:250px"
                                          placeholder="EG/P/YYYY/#####"
                                          clearable
                                          v-model="poa_reference_app_no"
                                          :error-messages="poa_reference_app_no ? errorText : errors"
                                          :success="isChecked && chkResult"
                                          :error="isChecked && !chkResult"
                                          :disabled="procStatus == 'VIEW'"
                                        >
                                        </v-text-field>
                                        <v-btn
                                          class="ft-size12 text-capitalize br_none new__check__btn"
                                          dense
                                          color="#a01c2a"
                                          dark
                                          width="95"
                                          height="40"
                                          @click="fnSearchApplication()"
                                        >{{ $t('common.button.check') }}</v-btn>
                                      </div>
                                      </ValidationProvider>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-radio-group>
                            </div>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="d-flex align-center justify-space-between pop__btn__wrap pt-0">
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'VIEW'"
                        @click="fnDeleteRepresentativeConfirm()"
                      >
                        {{ $t('common.button.delete') }}
                      </v-btn>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        outlined
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'MOD'"
                        @click="fnClosePopup()"
                      >
                        {{ $t('common.button.cancel') }}
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        dark
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'VIEW'"
                        @click="fnEditMod()"
                      >
                        {{ $t('common.button.edit') }}
                      </v-btn>
                      <v-btn
                        dense
                        height="50"
                        width="150"
                        dark
                        rounded
                        color="#a01c2a"
                        class="capitalize btn_basic"
                        v-if="procStatus == 'MOD'"
                        @click="fnSave()"
                      >
                        {{ $t('common.button.save') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </perfect-scrollbar>
            </v-form>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-dialog>

    <v-dialog v-model="confirm_dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('common.message.delete.confirm.title') }}</v-card-title>
        <v-card-text>{{ $t('common.message.delete.confirm.text') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="sb_btn btn-actv" @click="fnDeleteRepresentative()">{{ $t('common.button.yes') }}</v-btn>
          <v-btn class="sb_btn btn-dactv" @click="confirm_dialog = false">{{ $t('common.button.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  props: {
    seq : Number,
    receipt_no : String
  },
  components :{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      user_group_type_code: store.state.token.user_group_type_code,
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      mod_dialog: true,
      confirm_dialog: false,
      procStatus : 'MOD',
      valid: false,
      poaFile : null,

      countryArList: [],
      countryEnList: [],
      repScopeTypeListAr: [],
      repScopeTypeListEn: [],
      all_applicants: [],
      used_applicants: [],
      applicantList: [],
      selected_applicants: [],
      agentTypeCodeListAr: [],
      agentTypeCodeListEn: [],

      nationality_code : '',
      residence_country_code : '',
      name_ar : '',
      name_en : '',
      address_ar : '',
      address_en : '',
      pobox_ar : '',
      pobox_en : '',
      telephone : '',
      mobile : '',
      fax : '',
      email : '',
      agent_no : '',
      agent_type_code : '',
      rep_scope_type_code : '',
      poa_upload_type_code : '',
      poa_upload_type_codes : [],
      poa_reference_app_no : '',
      poa_file_key : '',
      poa_file_name : '',

      isChecked : false,
      chkResult : false,
      errorText : null,
    }
  },
  beforeCreate(){
    //국가목록
    utils.fnGetCountryList('en').then(list => {
      this.countryEnList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    utils.fnGetCountryList('ar').then(list => {
      this.countryArList = list
    }).catch((res)=>{
      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
    })

    //agent type 코드 목록
    let options = {
      upper_code: '3100'
    }
    utils.fnGetCodeList(options).then(list => {
      this.agentTypeCodeListAr = list.ar
      this.agentTypeCodeListEn = list.en
    })

    //대리인 범위 구분 코드 목록
    options = {
      upper_code: '5100'
    }
    utils.fnGetCodeList(options).then(list => {
      this.repScopeTypeListAr = list.ar
      this.repScopeTypeListEn = list.en
    })
  },
  mounted(){
    this.fnGetRepresentative()
  },
  watch: {
    date () { this.dateFormatted = this.formatDate(this.date)},
    poa_reference_app_no () {
      this.isChecked = false
      this.chkResult = false
      this.errorText = null
      this.$refs.observer.reset()
    }
  },
  methods: {
    fnGetRepresentative(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/representatives/'+this.seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.nationality_code != '') {
              this.nationality_code = res.data.nationality_code
            }

            if(res.data.residence_country_code != '') {
              this.residence_country_code = res.data.residence_country_code
            }

            if(res.data.agent_type_code != ''){
              this.agent_type_code = res.data.agent_type_code
            }

            this.name_ar = res.data.name_ar
            this.name_en = res.data.name_en
            this.address_ar = res.data.address_ar
            this.address_en = res.data.address_en
            this.pobox_ar = res.data.pobox_ar
            this.pobox_en = res.data.pobox_en
            this.telephone = res.data.telephone
            this.mobile = res.data.mobile
            this.fax = res.data.fax
            this.email = res.data.email
            this.agent_no = res.data.agent_no
            this.rep_scope_type_code = res.data.rep_scope_type_code
            this.poa_upload_type_code = res.data.poa_upload_type_code
            this.poa_upload_type_codes = res.data.poa_upload_type_codes
            this.poa_reference_app_no = res.data.poa_reference_app_no
            this.poa_file_key = res.data.poa_file_key
            this.poa_file_name = res.data.poa_file_name
            this.applicants = res.data.applicants

            if (this.poa_upload_type_codes.length === 0 && this.poa_upload_type_code) {
              this.poa_upload_type_codes.push(this.poa_upload_type_code)
            }

            let applicants = res.data.applicants

            res.data.applicants.forEach((item) => {
              this.selected_applicants.push(item.seq)
            })

            if (this.poa_reference_app_no !== '') {
              setTimeout(() => {
                this.isChecked = true
                this.chkResult = true
                this.errorText = null
              }, 500)
            }

            //Applicant 목록
            requestApi({
              url: '/receivings/'+this.receipt_no+'/applicants',
              method: 'GET',
              callback: (res2) => {
                if (res2.res_code === '200') {
                  //receipt_no가 일치하는 모든 applicant
                  let all_applicantList = res2.data.list

                  requestApi({
                    url: '/receivings/'+this.receipt_no+'/representatives',
                    method: 'GET',
                    callback: (res3) => {
                      if (res3.res_code === '200') {
                        let usedArray = []

                        for(let i=0; i<res3.data.list.length; i++){
                          let item_applicants = res3.data.list[i].applicants

                          for(let k=0; k<item_applicants.length; k++){
                            let isThisApplicant = false

                            for(let r=0; r<applicants.length; r++ ){
                              if(applicants[r].seq == item_applicants[k].seq){
                                isThisApplicant = true
                              }
                            }

                            if(!isThisApplicant){
                              usedArray.push(item_applicants[k])
                            }
                          }
                        }

                        let unUsedApplicants = []

                        for(let j=0; j < all_applicantList.length; j++){
                          let isUsed = false

                          for(let m=0; m < usedArray.length; m++){
                            if(all_applicantList[j].seq == usedArray[m].seq){
                              isUsed = true
                            }
                          }

                          if(!isUsed){
                            unUsedApplicants.push(all_applicantList[j])
                          }
                        }

                        this.applicantList = unUsedApplicants
                      } else {
                        if (res.res_code === '401012') {
                          utils.setTokenRefresh().then(() => {
                            this.fnGetRepresentative()
                          })
                        } else {
                          eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                        }
                      }
                    }
                  })
                } else {
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.fnGetRepresentative()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      let targetObj = document.querySelector('#representative_wrapper')
      targetObj.scrollTop = 0
      this.procStatus = 'MOD'
    },
    fnClosePopup(){
      this.$emit('success')
    },
    fnEditMod(){
      let targetObj = document.querySelector('#representative_wrapper')
      targetObj.scrollTop = 0
      this.procStatus = 'MOD'
    },
    fnSave(){
      this.$refs.observer.validate().then((valid) => {
        if(valid) {
          if(this.poa_upload_type_codes.join(',').indexOf('5203') > -1){
            if(!this.isChecked || !this.chkResult){
              let option = {
                text : this.$t('component.representative.check_application_no')
              }
              eventBus.$emit('SHOW_SNACKBAR', option)
              return
            }
          }

          this.fnUploadPOAFile().then( () => {
            let applicants = []
            if(this.rep_scope_type_code === '5102'){
              if(this.selected_applicants.length == 0){
                let option = {
                  text : this.$t('component.representative.message_no_select'),
                }
                eventBus.$emit('SHOW_SNACKBAR', option)

                return false
              } else {
                this.selected_applicants.forEach((item) => {
                  let appendItem = { seq : item }
                  applicants.push(appendItem)
                })
              }
            }

            if (this.poa_upload_type_codes.join(',').indexOf('5201') === -1) {
              this.poa_file_key = ''
            }

            if (this.poa_upload_type_codes.join(',').indexOf('5203') === -1) {
              this.poa_reference_app_no = ''
            }

            let params = {
              nationality_code : this.nationality_code,
              residence_country_code : this.residence_country_code,
              name_ar : this.name_ar,
              name_en : this.name_en,
              address_ar : this.address_ar,
              address_en : this.address_en,
              pobox_ar : this.pobox_ar,
              pobox_en : this.pobox_en,
              telephone : this.telephone,
              mobile : this.mobile,
              fax : this.fax,
              email : this.email,
              agent_no : this.agent_no,
              agent_type_code : this.agent_type_code,
              rep_scope_type_code : this.rep_scope_type_code,
              poa_upload_type_codes : this.poa_upload_type_codes,
              poa_reference_app_no : this.poa_reference_app_no,
              poa_file_key : this.poa_file_key,
              applicants : applicants
            }

            requestApi({
              url: '/receivings/'+this.receipt_no+'/representatives/'+this.seq,
              method: 'PUT',
              data: params,
              callback: (res) => {
                if(res.res_code === '200'){
                  let option = {
                    text : this.$t('common.message.modify.success'),
                  }
                  eventBus.$emit('SHOW_SNACKBAR', option)
                  this.$emit('success')
                }else{
                  if (res.res_code === '401012') {
                    utils.setTokenRefresh().then(() => {
                      this.fnSave()
                    })
                  } else {
                    eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                  }
                }
              }
            })
          }).catch(res => {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },

    fnUploadPOAFile(){
      //POA 업로드 구분 코드가 5201 이고, 업로드 할 이미지 파일이 있다면 업로드 실행
      let poaFile = this.poaFile
      let target = this
      let poa_upload_type_codes = this.poa_upload_type_codes

      return new Promise(function(resolve, reject){

        if(poaFile && poa_upload_type_codes.join(',').indexOf('5201') > -1){

          let formData = new FormData()
          formData.append("file_data", poaFile)

          requestApi({
            url: '/file/documents/upload',
            method: 'POST',
            data: formData,
            headers : {"Content-Type":"multipart/form-data"},
            callback: (res) => {
              // 파일저장
              if (res.res_code === '200') {
                target.poa_file_key = res.data.file_key
                resolve()
              }else{
                reject(res)
              }
            }
          })
        }else{
          resolve()
        }
      })
    },

    fnDeleteRepresentativeConfirm(){
      this.confirm_dialog = true
    },

    fnDeleteRepresentative(){
      requestApi({
        url: '/receivings/'+this.receipt_no+'/representatives/'+this.seq,
        method: 'DELETE',
        callback: (res) => {
          if(res.res_code === '200'){
            let option = {
              text : this.$t('common.message.delete.success'),
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
            //this.$emit('success')
            this.fnClosePopup()
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnDeleteRepresentative()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })

      //this.fnClosePopup()
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return ''
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    fnSearchApplication(){
      if(!this.poa_reference_app_no){
        let snackBarOptions = {
          text: this.$t('common.message.enter_application_no')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }

      let params = {
        application_no : this.poa_reference_app_no.trim(),
        ind_applicant_type_check: 'N'
      }

      requestApi({
        url: '/applications/search',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.isChecked = true
            this.chkResult = true
            this.errorText = null
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSearchApplication()
              })
            } else {
              this.isChecked = true
              this.chkResult = false

              this.errorText = this.$vuetify.rtl ? res.res_msg_ar : res.res_msg_en
            }
          }
        }
      })
    },

    fnInitFile() {
      this.poaFile = null
      this.poa_file_key = ''
      this.poa_file_name = ''
    },

    fnUploadFile() {
      if(!utils.isNull(this.poaFile)){
        let extList = []
        extList.push({name_en: 'pdf'})
        extList.push({name_en: 'jpg'})
        extList.push({name_en: 'gif'})

        if (utils.getFileExtLen(this.poaFile, extList, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            this.poaFile = null
            this.poa_file_key = ''
            this.poa_file_name = ''
          }, 100)
        }
      }
    },
  },
}
</script>

<style scoped>
  .v-input--selection-controls {
    margin-top: 5px;
    padding-top: 0px;
  }
</style>